import { ChangeEvent } from "react";
import { CurrencyItem, Item } from "../ui-kit";
import { DateTime } from "luxon";

export enum SearchFieldType {
  TEXT = "text",
  DATE = "date",
  DATE_RANGE = "dateRange",
  AMOUNT = "amount",
  AMOUNT_RANGE = "amountRange",
  DROPDOWN = "dropdown",
  CREATED_BY_DROPDOWN = "createdByDropdown",
  CATEGORY_DROPDOWN = "categoryDropdown",
  SUPPLIER_DROPDOWN = "supplierDropdown",
  BRAND_DROPDOWN = "brandDropdown",
  ROLE_DROPDOWN = "roleDropdown",
  PICKER_DROPDOWN = "pickerDropdown",
  LOCATION_DROPDOWN = "locationDropdown",
  SEARCH_BY_COMPANY_DROPDOWN = "searchByCompanyDropdown",
  SEARCH_BY_USER_DROPDOWN = "searchByUserDropdown",
  TERMINAL_DROPDOWN = "terminalDropdown",
  SHIPPING_COMPANY_DROPDOWN = "shippingCompanyDropdown",
  CHECKBOX = "checkbox",
  CHECKBOX_ARCHIVED = "checkboxArchieved",
  CURRENCY_DROPDOWN = "currencyDropdown",
  /** Static `dropdownValues` with a type-to-filter box — for long lists (countries). */
  SEARCHABLE_DROPDOWN = "searchableDropdown",
}

export type GenericEvent =
  | ChangeEvent<HTMLInputElement>
  | DateTime
  | Item
  | undefined;

export interface ISearchFieldConfig {
  type: SearchFieldType;
  key: string;
  rangeEndKey?: string;
  label: string;
  placeholder?: string;
  rangeEndPlaceholder?: string;
  dropdownValues?: Item[];
  /**
   * SEARCH_BY_COMPANY_DROPDOWN only: extra companies-list query params for the
   * options, e.g. `{ canManageCompanies: "true" }` to offer partners only.
   */
  companyQuery?: Record<string, string>;
}

export interface IAdvancedSearchProps {
  config: ISearchFieldConfig[];
  onChange: (filters: Record<string, any>) => void;
  className?: string;
  isLive?: boolean;
  defaultOpen?: boolean;
  restoredValues?: any;
  withoutFilterButton?: boolean;
  /** Placeholder for the top Search input (defaults to "Search"). */
  searchPlaceholder?: string;
  externalCurrentCurrency?: CurrencyItem;
  externalCurrencyItems?: CurrencyItem[]; // this is needed if the company context is called in a modal window
  disableCurrencyDropdown?: boolean;
}
